import React from "react";
import { NavLink, useNavigate } from "react-router-dom";

export default function MenuList({ items, vertical = true, onNavigate }) {
  const navigate = useNavigate();

  // --- 例: ここで最新日付リストを取得する関数を準備しておく ---
  const getLatestAiDates = () => {
    try {
      const stored = sessionStorage.getItem("aiDates");
      if (stored) return JSON.parse(stored);
    } catch (e) {
      console.warn("aiDates parse error", e);
    }
    return []; // デフォルト空配列
  };

  return (
    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
      {items.map((item, idx) => {
        const IconEl = item.icon ? (
          <span style={{ display: "inline-flex", alignItems: "center" }}>{item.icon}</span>
        ) : null;

        if (item.kind === "primary" || item.kind === "back") {
          const isPrimary = item.kind === "primary";
          return (
            <li key={idx} style={{ marginBottom: "0.5rem" }}>
              <button
                onClick={() => {
                  if (item.to === "/ai-interview-questions") {
                    const aiDates = getLatestAiDates();
                    navigate(item.to, { state: { aiDates } });
                  } else {
                    navigate(item.to);
                  }
                  onNavigate?.();
                }}
                style={{
                  width: "100%",
                  padding: "0.625rem 0.75rem",
                  fontSize: "1rem",
                  border: "none",
                  cursor: "pointer",
                  textAlign: "left",
                  borderRadius: 4,
                  backgroundColor: isPrimary ? "#0f62fe" : "transparent",
                  color: isPrimary ? "#fff" : "#0f62fe",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {IconEl}
                <span>{item.label}</span>
              </button>
            </li>
          );
        }

        return (
          <li key={item.to} style={{ marginBottom: "0.5rem" }}>
            <NavLink
              to={item.to}
              className={({ isActive }) =>
                `sidebar-link ${isActive ? "active" : ""}`
              }
              onClick={(e) => {
                if (item.to === "/ai-interview-questions") {
                  e.preventDefault();
                  const aiDates = getLatestAiDates();
                  navigate(item.to, { state: { aiDates } });
                }
                onNavigate?.();
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "0.5rem 0.75rem",
                borderRadius: 4,
                textDecoration: "none",
                color: "#161616",
              }}
            >
              {IconEl}
              <span>{item.label}</span>
            </NavLink>
          </li>
        );
      })}
    </ul>
  );
}
